import { render, staticRenderFns } from "./categories-carousel.vue?vue&type=template&id=7aa10af4"
import script from "./categories-carousel.vue?vue&type=script&lang=ts"
export * from "./categories-carousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa10af4')) {
      api.createRecord('7aa10af4', component.options)
    } else {
      api.reload('7aa10af4', component.options)
    }
    module.hot.accept("./categories-carousel.vue?vue&type=template&id=7aa10af4", function () {
      api.rerender('7aa10af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/categories-carousel.vue"
export default component.exports